import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_23c7bc37: FaireBrandEntity = {
  token: "b_23c7bc37",
  type: "brand",
  name: "GeoCentral",
  avatarUrl:
    "https://cdn.faire.com/fastly/7c53de36c858b697cf2c36f52977ef1c10d80778300a1bb3e5e4b29f966beeb4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/30daa9552f512b7010e3017cdc8f3592d65bd16c676ddef81947ddf52dc81c8b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7c53de36c858b697cf2c36f52977ef1c10d80778300a1bb3e5e4b29f966beeb4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/30daa9552f512b7010e3017cdc8f3592d65bd16c676ddef81947ddf52dc81c8b.png",
  location: "Mason, OH, USA",
  minimumOrderDollars: 208,
  rating: 4.9,
  reviewCount: 413,
  isTopShop: true,
  isInsider: true,
  description:
    "GeoCentral is a wholesale company, specializing in crystals, rocks, and souvenir goods since 1978. \n\nWhat began with selling handmade seashell crafts has grown across the globe. Through it all, our commitment to celebrating nature and unearthing rare, exquisite goods is the foundation of all we do.\n\nGeoCentral is proud to deliver unique, genuine, and beautiful products, while prioritizing ethics and sustainability.\n\nWe are best known for our boxed crystal collections - introducing users to daily crystal practices with easy-to-understand instructions and a wide variety of crystals, designed for easy merchandising. \n\nFeaturing one-of-a-kind crystals and rocks, on-trend wellness tools and education, distinctive home décor, jewelry, and children’s enrichment items, our collections are designed to inspire awe and elevate the every day.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:05.209Z",
    importedBy: "entity-db-cli",
  },
};
